import moment from "moment";

export const calculateStockoutDate = (
    stockoutDate: string,
    leadTime: { duration: string; value: number }
) => {
    if (!stockoutDate || !leadTime?.value) return null;

    const stockoutMoment = moment(stockoutDate);
    if (!stockoutMoment.isValid()) return null;

    let reorderDate;
    switch (leadTime.duration?.toLowerCase()) {
        case "days":
            reorderDate = stockoutMoment.subtract(leadTime.value, "days");
            break;
        case "weeks":
            reorderDate = stockoutMoment.subtract(leadTime.value, "weeks");
            break;
        case "months":
            reorderDate = stockoutMoment.subtract(leadTime.value, "months");
            break;
        case "years":
            reorderDate = stockoutMoment.subtract(leadTime.value, "years");
            break;
        default:
            // Default to days if duration is not specified
            reorderDate = stockoutMoment.subtract(leadTime.value, "days");
    }

    return reorderDate;
};
